import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBrush: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaintBrush"><Path d="M20 15H14.5L14.8008 19.5068C14.9087 21.1267 13.6235 22.5 12 22.5C10.3765 22.5 9.09135 21.1267 9.19922 19.5068L9.5 15H4V12H20V15Z" fill="currentColor"/><Path d="M8.5 2L10 4L11.5 2H20V10H4V2H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaintBrush;
